
import "../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_InfoIcon";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_InfoIcon__root","icon":"wds_1_209_0_InfoIcon__icon"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-text-primary":"--wds-color-text-primary","wds-info-icon-fill":"--wds-info-icon-fill","wds-info-icon-fill-hover":"--wds-info-icon-fill-hover"}; 




